const findCompletedField = (completedFields: any, fieldName: any) => {
  let showField = true;
  Object.keys(completedFields).forEach((key: string) => {
    if (completedFields[key] === fieldName) showField = false;
  });
  return showField;
};
// Removes fields that are already completed
const filterCompletedFields = (completedFields: any, steps: any) => {
  return steps.map(({ fields, ...step }: any) => {
    return Object.assign(step, {
      fields: fields.filter((field: any) =>
        findCompletedField(completedFields, field.fieldId)
      ),
    });
  });
};

export default filterCompletedFields;
